export default "__VITE_ASSET__L_SFe3Eq__"